import { render, staticRenderFns } from "./DownloadPluginsTablePage.vue?vue&type=template&id=4e67bfc0&scoped=true"
import script from "./DownloadPluginsTablePage.vue?vue&type=script&lang=js"
export * from "./DownloadPluginsTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e67bfc0",
  null
  
)

export default component.exports